/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';
import * as API from '../utils/api';
import { applicationError } from './notificationActions';
import { fetchAllWorkPackages } from './workPackageActions';
import Store from '../store/store';

export function fetchTeamDefaultOptions() {
  return dispatch => {
    dispatch({ type: Types.REQUEST_DEFAULT_OPTIONS });
    return API.get('default_options')
      .then(response => {
        // const currentTeams =
        //   localStorage.currentTeams && localStorage.currentTeams.length > 0
        //     ? JSON.parse(localStorage.getItem('currentTeams'))
        //     : [{ ...response.current_team }];
        // const currentProducts =
        //   localStorage.currentProducts &&
        //   localStorage.currentProducts.length > 0
        //     ? JSON.parse(localStorage.getItem('currentProducts'))
        //     : [{ ...response.current_product }];
        const browserId = new Date().valueOf().toString();
        const defaultOptions = { ...response, current_team: undefined };
        return dispatch({
          type: Types.RECEIVE_TEAM_DEFAULT_OPTIONS,
          defaultOptions,
          browserId
        });
      })
      .catch(error => {
        dispatch(applicationError(error));
        dispatch({ type: Types.REQUEST_DEFAULT_OPTIONS_FAILED });
      });
  };
}
export function fetchDefaultOptions(id) {
  return dispatch => {
    dispatch({ type: Types.REQUEST_DEFAULT_OPTIONS });
    return API.get(`default_options/${id}`)
      .then(response =>
        dispatch({
          type: Types.RECEIVE_DEFAULT_OPTIONS,
          defaultOption: response.default_option
        })
      )
      .catch(error => dispatch(applicationError(error)));
  };
}

// export function createDefaultOptions(data) {
//   return (dispatch) => {
//     dispatch({ type: Types.SEND_DEFAULT_OPTIONS });
//     return API.post('default_options', data)
//       .catch(error => dispatch(applicationError(error)));
//   };
// }

export function updateDefaultOptions(id, data) {
  return dispatch => {
    dispatch({ type: Types.UPDATE_DEFAULT_OPTIONS });
    return API.put(`default_options/${id}`, data).catch(error =>
      dispatch(applicationError(error))
    );
  };
}

export function deleteDefaultOptions(id) {
  return dispatch => {
    dispatch({ type: Types.UPDATE_DEFAULT_OPTIONS });
    return API.del(`default_options/${id}`)
      .then(() => fetchTeamDefaultOptions())
      .catch(error => dispatch(applicationError(error)));
  };
}

export function setCurrentTeams(teamIdsArray, authenticating = false) {
  return dispatch => {
    // grab teas from teams reducer
    const { teams } = Store.getState().teamReducer;
    // zip them with teamIdsArray
    const currentTeams = teams.filter(team =>
      teamIdsArray.some(tid => tid === team.id)
    );

    // store that zipped array in the next dispatch
    dispatch({
      type: Types.SET_CURRENT_TEAMS,
      currentTeams,
      currentTeamIds: teamIdsArray
    });
    if (!authenticating)
      dispatch({ type: Types.SPACES_SPINNER, activeSpacesSpinner: true });
  };
}

export function setCurrentProducts(productIdsArray, authenticating) {
  return dispatch => {
    // grab products from products reducer,
    const { products } = Store.getState().productReducer;
    // zip them with productIdsArray
    const currentProducts = products.filter(prod =>
      productIdsArray.some(pid => pid === prod.id)
    );
    // store that zipped array in the next dispatch
    dispatch({
      type: Types.SET_CURRENT_PRODUCTS,
      currentProducts,
      currentProductIds: productIdsArray
    });
    if (!authenticating)
      dispatch({ type: Types.SPACES_SPINNER, activeSpacesSpinner: true });
  };
}

export function setCurrentFilterPrimary(currentFilterPrimary) {
  const primary = currentPrimary || [];
  return dispatch => {
    sessionStorage.setItem(
      'currentFilterPrimary',
      JSON.stringify(currentPrimary)
    );
    dispatch({ type: Types.SET_CURRENT_PRIMARY, currentPrimary: primary });
    dispatch({ type: Types.WORK_PACKAGES_INITIAL_STATE });
    dispatch({ type: Types.CADENCES_INITIAL_STATE });
    dispatch({ type: Types.TASKS_INITIAL_STATE });
  };
}

export function updateWorkPackageSearchText(searchText) {
  return dispatch => {
    dispatch({ type: Types.UPDATE_WORKPACKAGE_SEARCH_TEXT, searchText });
  };
}

export function resetWorkPackageSearchText() {
  return dispatch => {
    dispatch({ type: Types.RESET_WORKPACKAGE_SEARCH_TEXT });
  };
}
